/** @file fillPath: a REST_ROUTES path template with each {name} replaced by its encoded value. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import { throwError } from '@zilo/pose3d-std/errors/throwError';

/** `'/api/v1/puppets/{id}'` + `{ id: 'pup_1' }` → `'/api/v1/puppets/pup_1'`; a missing value is `VALIDATION`. */
export function fillPath(template: string, params: Record<string, string>): string {
  return template.replace(/\{([^}]+)\}/g, (_, name: string) => {
    const value = params[name];
    if (value === undefined) return throwError(ERROR_CODES.VALIDATION, { param: name, template }, { hint: `pass ${name}` });
    return encodeURIComponent(value);
  });
}
